import api from "../api";

// All Trainers Registrations
export const fetchTrainersRegistrations = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/data/trainers-registrations`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.registrations || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.registrations || error.message
    );
    throw error;
  }
};